import React, { Component } from "react";
import { toJS } from "mobx";
import { observer, inject } from "mobx-react";
import { Link } from "react-router-dom";
import { RIEInput } from "riek";
import Http from "axios";
import config from "../config";
import localForage from "localforage";
import { toast } from "react-toastify";

@inject("CartStore", "AdminStore")
@observer
class ProductItem extends Component {
  constructor(props) {
    super(props);
    this.state = { selectedDays: 1, name: "", qty: 0, price: 0 };
  }

  componentDidMount() {
    localForage.getItem("cart").then(items => {
      this.props.CartStore.setCart(items);
    });
  }

  inCart() {
    const filteredCart = this.props.CartStore.items
      ? this.props.CartStore.items.filter(
          item => item._id === this.props.product._id
        )[0]
      : null;
    return filteredCart ? true : false;
  }

  selectAllInput(ref) {
    ref.setSelectionRange(0, (this.state.selectedDays + "").length);
  }

  editItem(e) {
    Http.put(
      config.api + "/admin/products",
      { ...e, _id: this.props.product._id },
      {
        withCredentials: true
      }
    ).then(product => {
      e.pricePerDay
        ? this.setState({
            price: e.pricePerDay
          })
        : this.setState(e);
      toast.info("Edited product successfully");
    });
  }

  toggleFeatured = product => {
    Http.post(
      `${config.api}/admin/products/${
        product.featured || this.state.featuredSet
          ? "removeFeatured"
          : "addFeatured"
      }`,
      {
        productId: product._id
      },
      {
        withCredentials: true
      }
    ).then(product => {
      this.props.AdminStore.modifyProduct(product.data.result);
      product.featured || this.state.featuredSet
        ? toast.info("Removed product from featured")
        : toast.info("Added product to featured");
    });
  };

  render() {
    const downloadable = this.props.product.available === "downloadable";
    return (
      <div
        className={
          "item" + (this.props.downloadMode ? " downloadable-item" : "")
        }
      >
        {this.props.editMode ? (
          <div
            className={
              "mark-featured" + (this.props.product.featured ? "" : " inactive")
            }
            onClick={() => this.toggleFeatured(this.props.product)}
          >
            {this.props.product.featured ? "Featured" : "Add as Featured"}
          </div>
        ) : null}
        {!this.props.editMode && !this.props.downloadMode && !downloadable ? (
          this.inCart() ? (
            <div
              className="remove-item"
              onClick={() =>
                this.props.CartStore.removeFromCart(this.props.product, true)
              }
            >
              <i className="fa fa-minus" />
            </div>
          ) : (
            <div
              className="add-item"
              onClick={() =>
                this.props.CartStore.addToCart(
                  {
                    ...toJS(this.props.product),
                    days: this.state.selectedDays
                  },
                  1
                )
              }
            >
              <i className="fa fa-plus" />
            </div>
          )
        ) : !this.props.downloadMode && !downloadable ? (
          <div
            className="remove-item"
            onClick={() =>
              this.props.AdminStore.removeProduct(this.props.product._id)
            }
          >
            <i className="fa fa-close" />
          </div>
        ) : null}
        <Link to={`/Shop/${this.props.product._id}`}>
          <img src={this.props.image} alt="" />
        </Link>
        <div className="item-desc">
          {this.props.editMode ? (
            <RIEInput
              propName="name"
              value={
                this.props.name && !this.state.name
                  ? this.props.name
                  : this.state.name
                  ? this.state.name
                  : 0
              }
              change={e => {
                this.editItem(e);
              }}
            />
          ) : (
            <Link to={`/Shop/${this.props.product._id}`}>
              <p>{this.props.name}</p>
            </Link>
          )}
          <div className="item-pricing">
            {this.props.editMode ? (
              <div>
                x
                <RIEInput
                  propName="qty"
                  value={
                    this.props.qty && !this.state.qty
                      ? this.props.qty
                      : this.state.qty
                      ? this.state.qty
                      : 0
                  }
                  change={e => {
                    this.editItem(e);
                  }}
                />
              </div>
            ) : this.props.downloadMode || downloadable ? null : (
              <p>
                {/* <input
                  class="days-inp"
                  name="days"
                  type="number"
                  min={1}
                  onChange={e =>
                    this.setState({
                      selectedDays: e.target.value > 0 ? e.target.value : 1
                    })
                  }
                  defaultValue={this.state.selectedDays}
                />{" "}
                Days */}
              </p>
            )}
            <p className="costs">
              $
              {downloadable ? (
                this.props.product.price
              ) : this.props.editMode ? (
                <RIEInput
                  propName="pricePerDay"
                  value={parseInt(
                    this.props.price && !this.state.price
                      ? this.props.price
                      : this.state.price
                      ? this.state.price
                      : 0,
                    10
                  ).toFixed(2)}
                  change={e => {
                    this.editItem(e);
                  }}
                />
              ) : parseInt(this.state.selectedDays, 10) === 1 ? (
                this.props.price
              ) : parseInt(this.state.selectedDays, 10) === 2 ? (
                this.props.price * 1.7
              ) : parseInt(this.state.selectedDays, 10) === 3 ? (
                this.props.price * 1.95
              ) : parseInt(this.state.selectedDays, 10) >= 4 &&
                parseInt(this.state.selectedDays, 10) <= 7 ? (
                this.props.price * 2.95
              ) : (
                (
                  this.props.price * 2.95 +
                  (parseInt(this.state.selectedDays, 10) - 7) *
                    this.props.price *
                    0.42
                ).toFixed(2)
              )}
              {!downloadable ? (
                <span
                  style={{
                    fontSize: 16,
                    margin: 0,
                    marginBottom: 2,
                    color: "#0088cd",
                    opacity: 0.8
                  }}
                >
                  /day
                </span>
              ) : null}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductItem;



// WEBPACK FOOTER //
// ./src/components/ProductItem.js